import React, { useState, useEffect } from 'react';
import Layout from '../../layouts/Layout';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { deleteProductAPI, getProductListAPI } from '../../services/api/ProductAPI';

const Products = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const user = useSelector((state) => state.LoginReducer.authData);
    const token = user.data.token;
    const [loading, setLoading] = useState(true);

    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };

    useEffect(() => {
        fetchProductsList();
    }, []);

    const fetchProductsList = async () => {
        try {
            const data = await getProductListAPI(token);
            if(data.status){
                setProducts(data.data);
            }
        } catch (error) {
            console.error('Error fetching user list:', error);
        } finally {
        }
    };

    const handleEdit = (id) => {
        navigate(`/products/edit-product/${id}`);
    };
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                const data = await deleteProductAPI(id, token);
                if(data.status){
                    fetchProductsList();
                    Swal.fire(
                        'Deleted!',
                        'Product has been deleted.',
                        'success'
                    );
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    'Something went wrong please try again.',
                    'error'
                );
            }
        }
    };

    return (
        <Layout title="Products">
            <div className="container table-container">
            <div className='d-flex justify-content-between'>
                    <div className="mb-2 custom-input-group">
                        <FaSearch className="search-icon" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" className="flex-grow-1" />
                    </div>
                    <div className="">
                        <Link to={'/products/create-product'} className='btn btn-primary'>Add Product</Link>
                    </div>
                </div>
                <DataTable value={products} paginator rows={10} sortField="name" sortOrder={1} removableSort stripedRows globalFilter={globalFilterValue} rowsPerPageOptions={[10, 25, 50, 100]}  emptyMessage={<span className="custom-empty-message">No records found</span>} >
                    <Column field="id" header="ID" sortable></Column>
                    <Column header="Image"
                        body={(product) => (
                            <img src={product.image} alt={product.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                        )}>
                    </Column>
                    <Column field="name" header="Name" sortable></Column>
                    <Column field="sku" header="SKU" sortable></Column>
                    {/* <Column field="available_stock" header="Available Stock" sortable></Column> */}
                    <Column
                        field="regular_price"
                        header="Regular Price"
                        body={(rowData) => '$'+rowData.regular_price}
                        sortable
                    />
                    {/* <Column
                        field="sale_price"
                        header="Sale Price"
                        body={(rowData) => '$'+rowData.sale_price}
                        sortable
                    /> */}
                    <Column 
                        header="Actions" 
                        body={(rowData) => (
                            <div className='d-flex gap-2 align-items-center'>
                                <button onClick={() => handleEdit(rowData.id)} className="btn btn-warning edit"><FaEdit className='' /></button>
                                <button onClick={() => handleDelete(rowData.id)} className="btn btn-danger delete"><FaTrash className='' /></button>
                            </div>
                        )}>
                    </Column>
                </DataTable>
            </div>
        </Layout>
    )
}

export default Products;